<template>
    <org-unit-details :orgUnitId="props.orgUnitId">
        <div class="col-span-12 lg:col-span-10">
            <vx-alert v-if="recentlyCreated" color="success" :closeable="false" class="mb-6" shadow>
                <template v-slot:icon>
                    <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                </template>
                <div class="flex items-center justify-between">
                    <span><strong>New Organizational Unit</strong> created successfully. Add groups below.</span>
                    <vx-button :href="`/settings/teams/${teamId}#/org-units`" size="sm" color="success"
                        >Back to OUs <font-awesome-icon widthAuto :icon="faSquareArrowUpLeft"></font-awesome-icon>
                    </vx-button>
                </div>
            </vx-alert>

            <page-header class="mb-2 md:mb-2"> Groups </page-header>

            <org-unit-group-list :orgUnit="orgUnit"></org-unit-group-list>
        </div>
    </org-unit-details>
</template>

<script setup>
import OrgUnitDetails from '../OrgUnitDetails.vue';
import OrgUnitGroupList from '../../groups/OrgUnitGroupList.vue';
import { VxAlert, VxButton } from '@voxie/frontend-components';
import { computed } from 'vue';
import dayjs from 'dayjs';
import { faCircleCheck, faSquareArrowUpLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useOrgUnitDetails } from '../useOrgUnitDetails';
import PageHeader from '~/components/general/PageHeader.vue';

const teamId = Spark.state.currentTeam.id;
const { orgUnit } = useOrgUnitDetails();

const props = defineProps({
    orgUnitId: {
        type: Number,
        required: true,
    },
});

const recentlyCreated = computed(() =>
    orgUnit.value.created_at ? dayjs.utc(orgUnit.value.created_at).isAfter(dayjs().subtract(15, 'seconds')) : false
);
</script>
